import { IElectricityContractRepository } from '@modules/electricity-contract/domain'
import { coreAxios } from '@infrastructure/apiService'

export const electricityContractService: IElectricityContractRepository = {
  hasElectricityContract: async (cups: string) => {
    try {
      const { data } = await coreAxios.get('/contracts', { params: { cups } })

      return Boolean(data)
    } catch (error) {
      const status = error.response?.status

      // 404: no hay contrato eléctrico asociado, seguir por la rama de alta nueva.
      if (status === 404) return true

      // 409: conflicto porque ya existe un contrato asociado, seguir por upselling.
      if (status === 409) return false

      throw error
    }
  },
  getContractByCups: async (cups) => {
    const { data } = await coreAxios.get(`/private/contract/${cups}/status`)

    const { contractId: id, status, productId, solarProjectId } = data

    return {
      id,
      status,
      productId,
      solarProjectId,
    }
  },
}
